declare global {
  interface Window {
    __APP_CONFIG__?: Record<string, string | undefined>;
  }

  interface ImportMetaEnv {
    readonly VITE_API_BASE_URL?: string;
    readonly VITE_MOCK_MODE?: string;
    readonly VITE_FIREBASE_API_KEY?: string;
    readonly VITE_FIREBASE_AUTH_DOMAIN?: string;
    readonly VITE_FIREBASE_PROJECT_ID?: string;
    readonly VITE_FIREBASE_APP_ID?: string;
    readonly VITE_FIREBASE_STORAGE_BUCKET?: string;
    readonly VITE_GOOGLE_FONTS_API_KEY?: string;
    DEV: boolean;
  }
  interface ImportMeta {
    readonly env: ImportMetaEnv;
  }
}

/** The runtime config of the host. It is empty if there is no window. */
const APP_CONFIG: Record<string, string | undefined> =
  (typeof window !== 'undefined' && window.__APP_CONFIG__) || {};

export const API_BASE_URL =
  APP_CONFIG.API_BASE_URL ??
  import.meta.env.VITE_API_BASE_URL ??
  '';

const MOCK_MODE_SETTING =
  APP_CONFIG.MOCK_MODE ?? import.meta.env.VITE_MOCK_MODE ?? 'false';

export const MOCK_MODE = MOCK_MODE_SETTING === 'true';

export const PARTIAL_MOCK = MOCK_MODE_SETTING === 'partial';

export const IS_DEV = import.meta.env.DEV === true;

export const FIREBASE_CONFIG = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? '',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? '',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? '',
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? '',
} as const;

const FIRESTORE_KEYS = ['apiKey', 'authDomain', 'projectId', 'appId'] as const;

export const FIRESTORE_ENABLED =
  !MOCK_MODE && !PARTIAL_MOCK && FIRESTORE_KEYS.every((key) => !!FIREBASE_CONFIG[key]);

/** True if the app can read branding images from Cloud Storage through Firebase. */
export const STORAGE_ENABLED = FIRESTORE_ENABLED && !!FIREBASE_CONFIG.storageBucket;

/** A browser key for the Google Fonts Developer API, restricted to this site's referrer. Optional. */
export const GOOGLE_FONTS_API_KEY = import.meta.env.VITE_GOOGLE_FONTS_API_KEY ?? '';
